import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=1f4bce6e&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=1f4bce6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bce6e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/customer.vue
// module id = null
// module chunks = 